// extracted by mini-css-extract-plugin
module.exports = {"input_box":"addtask_input_box__1GTkG","option_list":"addtask_option_list__3GvhB","div":"addtask_div__nd4wf","option":"addtask_option__1LY1r","div1":"addtask_div1__1xAl6"};